<template>
  <div>
    <Modal v-model="deployModal" width="1000" title="部署控制台" footer-hide>
      <Row class="stack-deploy-modal-row">
        <Col :xs="24" :sm="24" :md="24" :lg="8" style="border-right: 1px #e8eaec dashed; height: 380px;">
          <div style="margin-bottom: 5px">
            <Row style="margin-bottom: 5px">
              <span>部署状态：</span>
              <span v-if="deployTask.status === 'in_queue'">
                <Icon type="md-clock" size="18" style="color: #2d8cf0" /><span style="color: #2d8cf0"> 队列中</span>
              </span>
              <span v-else-if="deployTask.status === 'finish'">
                <Icon type="md-checkmark" size="18" style="color: #19be6b" /><span style="color: #19be6b"> 完成</span>
              </span>
              <span v-else-if="deployTask.status === 'starting'">
                <Icon type="ios-loading" size="18" style="color: #ff9900; animation: ani-demo-spin 1s linear infinite" />
                <span style="color: #ff9900"> 部署中</span>
              </span>
              <span v-else-if="deployTask.status === 'paused'">
                <Icon type="ios-pause" size="18" style="color: #ff9900;" />
                <span style="color: #ff9900"> 暂停</span>
              </span>
              <span v-else-if="deployTask.status === 'stop'">
                <Icon type="md-warning" size="18" style="color: #ed4014;" />
                <span style="color: #ed4014"> 已停止</span>
              </span>
            </Row>
            <Button type="primary" :disabled="deployTask.status !== 'paused'" @click="startDeploy(deployTask.current_step)" :loading="deployTask.status === 'paused' && actionLoading" size="small" style="margin-right: 5px; margin-bottom: 5px;">从当前步骤开始执行</Button>
            <Button type="primary" :disabled="deployTask.status !== 'paused' || deployTask.current_step + 1 > deployTask.rough_step.length" @click="startDeploy(deployTask.current_step + 1)" :loading="deployTask.status === 'paused' && actionLoading" size="small" style="margin-right: 5px; margin-bottom: 5px;">执行下一步</Button>
            <Button type="error" :disabled="deployTask.status !== 'paused'" @click="overTask" size="small" style="margin-right: 5px; margin-bottom: 5px;" :loading="deployTask.status === 'paused' && actionLoading">结束任务</Button>
          </div>
          <Steps direction="vertical" class="deploy-steps">
            <Step :id="`container-deploy-step-${index}`" :title="'容器' + item.serial" :content="item.name" v-for="(item, index) in deployTask.rough_step" :key="'stepT_' + index" :status="item.status"></Step>
          </Steps>
        </Col>
        <Col :xs="24" :sm="24" :md="24" :lg="16">
          <div class="content">
            <div class="main" style="padding-top: 0">
              <div>
                <Row class="title" >
                  <h4 :style="{float: 'left'}">部署日志</h4>
                  <a v-on:click="getTask()" style="line-height: 32px; padding-left: 10px">
                    <Icon type="md-refresh" :class="{ 'demo-spin-icon-load': refreshing }" size="18"/>
                  </a>
                </Row>
                <div v-if="deployTask.logs">
                  <div class="deploy-steps" ref="xwBody">
                    <ul v-for="(content, tIndex) in deployTask.logs" :key="tIndex">
                      <li v-for="(console, eIndex) in content.console" :key="tIndex + '_' + eIndex">
                        <span>{{ moment(console.time).format('YYYY-MM-DD HH:mm:ss') }} </span>
                        <span :style="{ color: console.color }"> {{ console.content }}</span>
                      </li>
                      <li v-if="tIndex < deployTask.logs.length - 1">==========================================================</li>
                    </ul>
                    <div style="color: #999" v-if="deployTask.status === 'starting' || deployTask.status === 'in_queue'">
                      <span v-if="$store.state.ws.socket.isConnected">
                        正在等待结果......
                      </span>
                      <span v-else>
                        正在等待结果...... 请手动点击<a v-on:click="getTask()">刷新</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import { detailContainerStackDeployTask, deployContainerStack, stopDeployContainerStack } from '@/api/container/stack'
import moment from 'moment'

export default {
  name: 'deploy-modal',
  data () {
    return {
      deployModal: false,
      deployTask: {},
      currentStep: '',
      taskId: null,
      stackId: null,
      refreshing: false,
      lastStatus: null,
      moment: moment,
      actionLoading: false
    }
  },
  created: function () {
    this.listener()
  },
  methods: {
    // 打开模态框
    openModal (taskId, stackId) {
      if (taskId) {
        this.stackId = stackId
        this.taskId = taskId
        this.getTask()
        this.deployModal = true
      } else {
        this.$Notice.error({
          title: '任务不存在！'
        })
      }
    },
    // 获取任务
    getTask () {
      if (this.taskId) {
        this.refreshing = true
        detailContainerStackDeployTask(this.taskId).then(res => {
          this.refreshing = false
          this.deployTask = res.data
          if (this.deployTask.status !== this.lastStatus) {
            this.$emit('callback')
            this.lastStatus = this.deployTask.status
          }
          this.scrollToBottom()
          this.$nextTick(function () {
            document.querySelector(`#container-deploy-step-${res.data.current_step}`).scrollIntoView(true)
          })
        }).catch(res => {
          this.refreshing = false
          this.$Notice.error({
            title: '获取任务数据失败！'
          })
          console.log(res.response)
        })
      }
    },
    // 开始部署
    startDeploy (step) {
      let reqData = {
        task_id: this.taskId,
        start_step: step
      }
      this.actionLoading = true
      deployContainerStack(reqData, this.stackId).then(res => {
        this.getTask()
        this.$emit('callback')
        this.$Notice.success({ title: '操作成功，堆栈开始部署！' })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败!',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 结束任务
    overTask () {
      if (this.taskId) {
        this.actionLoading = true
        stopDeployContainerStack({ task_id: this.taskId }, this.stackId).then(res => {
          this.$Notice.success({ title: '操作成功！' })
          this.$emit('callback')
          this.getTask()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '操作失败!',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！服务器无响应'
            })
          }
        })
      }
    },
    // 监听WS消息
    listener () {
      this.$options.sockets.onmessage = (data) => {
        const fData = JSON.parse(data.data)
        if (fData.group === 'message' && fData.service === 'container' && fData.module === 'stack') {
          if (fData.data) {
            if (fData.data.stack_task_id === this.taskId) {
              this.getTask()
            }
          }
        }
      }
    },
    // 滚动条到最底部
    scrollToBottom () {
      setTimeout(() => {
        if (this.$refs.xwBody) {
          // 滚动条长度
          let currentDistance = this.$refs.xwBody.scrollHeight - this.$refs.xwBody.clientHeight
          // 当前滚动条距离顶部的距离
          let currentScrollY = this.$refs.xwBody.scrollTop
          if (currentDistance > 0 && currentDistance > currentScrollY) {
            currentScrollY = Math.ceil((currentDistance - currentScrollY) / 10) + currentScrollY
            currentScrollY = currentScrollY > currentDistance ? currentDistance : currentScrollY
            // 微信和qq浏览器不支持 scrollTo？
            // this.$refs.xwBody.scrollTo(0,currentScrollY);
            this.$refs.xwBody.scrollTop = currentScrollY
            this.scrollToBottom()
          }
        }
      }, 13)
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../base.less';
  .stack-deploy-modal-row li {
    list-style-type: none;
  }
  .stack-deploy-modal-row li span {
    font-size: 14px;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .logs-scroll-bar {
    height: 600px;
  }
  .jv-container.jv-light {
    background: none !important;
  }
  .deploy-steps {
    padding: 0;
    overflow-y: auto;
    max-height: 600px;
    min-height: 600px;
    padding-bottom: 5px;
  }
  .deploy-steps::-webkit-scrollbar {
    width: 5px;
  }
  .deploy-steps::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .deploy-steps::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
